// extracted by mini-css-extract-plugin
export default {"container":"switcher_container__OiHS6"};